import type { Desconto } from '@/models'
import { formatarCnpjOuCpf, formatarMoeda, removerFormatacaoDeCnpjOuCpf } from './formatadores'

export type PagamentoDoMotivo = {
	valor: number
	formaDePagamento?: string | null
}

export type DadosDoMotivoDeAutenticacao = {
	motivo: string
	cliente?: string | null
	valorDaVenda: number
	limiteDisponivel?: number
	limitePorCompra?: number
	limitesPorCompra?: PagamentoDoMotivo[]
	pagamentos?: PagamentoDoMotivo[]
	cnpjOuCpf?: string | null
}

const moeda = (valor: number) => `R$ ${formatarMoeda(Number(valor) || 0)}`
const comForma = (item: PagamentoDoMotivo) => item.formaDePagamento ? ` (${item.formaDePagamento})` : ''

const rotuloDoDocumento = (documento: string) => {
	const tamanho = removerFormatacaoDeCnpjOuCpf(documento).length
	if (tamanho === 11) return 'CPF'
	if (tamanho === 14) return 'CNPJ'
	return 'CPF/CNPJ'
}

export function descreverDescontoParaMotivo(desconto: Desconto): string {
	return desconto.isPercentual
		? `${formatarMoeda(desconto.valor)}%`
		: moeda(desconto.valor)
}

export function montarMotivoDeAutenticacao(dados: DadosDoMotivoDeAutenticacao): string {
	const linhas = [`Motivo: ${dados.motivo}`]
	if (dados.cliente) linhas.push(`Cliente: ${dados.cliente}`)
	if (dados.cliente && dados.cnpjOuCpf) linhas.push(`${rotuloDoDocumento(dados.cnpjOuCpf)}: ${formatarCnpjOuCpf(dados.cnpjOuCpf)}`)
	linhas.push(`Valor da venda: ${moeda(dados.valorDaVenda)}`)
	if (dados.limiteDisponivel !== undefined) linhas.push(`Limite disponível: ${moeda(Math.max(0, dados.limiteDisponivel))}`)
	if (dados.limitePorCompra !== undefined) linhas.push(`Limite por compra: ${moeda(dados.limitePorCompra)}`)
	for (const limite of dados.limitesPorCompra || []) {
		linhas.push(`Limite por compra: ${moeda(limite.valor)}${comForma(limite)}`)
	}
	for (const pagamento of dados.pagamentos || []) {
		linhas.push(`Pagamento: ${moeda(pagamento.valor)}${comForma(pagamento)}`)
	}
	return linhas.join('\n')
}
